import { createSlice } from "@reduxjs/toolkit";
import { logoutUser } from "../actions/account";
import {
    getActiveLogBulkEditJobsByTag,
    getBulkEditJobById,
    getBulkEditJobByModule,
    getBulkEditJobByTagId
} from "../actions/bulkEditJobs";
import { editBulkGoals } from "../actions/goals";

const initialState = {
    error: false,
    isLoadingGetBulkEditJobById: false,
    isLoadingGetBulkEditJobByTagId: false,
    isLoadingGetBulkEditJobByModule: false,
    isLoadingActiveLogBulkEditJobs: false,
    activeLogBulkEditJobs: [],
    activeLogBulkEditJobsTagId: null,
    activeLogBulkEditJobsRequestId: null,
    activeLogBulkEditJobsError: false,
    jobDetails: {}
};

const jobSlice = createSlice({
    name: "job",
    initialState,
    reducers: {
        "account/logoutUser": (state) => initialState
    },
    extraReducers: {
        [getBulkEditJobById.pending]: (state, action) => {
            state.isLoadingGetBulkEditJobById = true;
            state.error = false;
        },
        [getBulkEditJobById.fulfilled]: (state, action) => {
            state.isLoadingGetBulkEditJobById = false;
            state.jobDetails = action?.payload;
            state.error = false;
        },
        [getBulkEditJobById.rejected]: (state, action) => {
            state.isLoadingGetBulkEditJobById = false;
            state.error = true;
        },
        [getBulkEditJobByTagId.pending]: (state, action) => {
            state.isLoadingGetBulkEditJobByTagId = true;
            state.error = false;
        },
        [getBulkEditJobByTagId.fulfilled]: (state, action) => {
            state.isLoadingGetBulkEditJobByTagId = false;
            state.jobDetails = action?.payload;
            state.error = false;
        },
        [getBulkEditJobByTagId.rejected]: (state, action) => {
            state.isLoadingGetBulkEditJobByTagId = false;
            state.error = true;
        },
        [getActiveLogBulkEditJobsByTag.pending]: (state, action) => {
            const requestedTagId = String(action?.meta?.arg?.tagId || "");

            if (state.activeLogBulkEditJobsTagId !== requestedTagId) {
                state.activeLogBulkEditJobs = [];
            }
            state.activeLogBulkEditJobsTagId = requestedTagId;
            state.activeLogBulkEditJobsRequestId = action.meta.requestId;
            state.isLoadingActiveLogBulkEditJobs = true;
            state.activeLogBulkEditJobsError = false;
        },
        [getActiveLogBulkEditJobsByTag.fulfilled]: (state, action) => {
            if (state.activeLogBulkEditJobsRequestId !== action.meta.requestId) return;

            state.isLoadingActiveLogBulkEditJobs = false;
            state.activeLogBulkEditJobs = action?.payload?.jobs || [];
            state.activeLogBulkEditJobsTagId = action?.payload?.tagId || null;
            state.activeLogBulkEditJobsError = false;
        },
        [getActiveLogBulkEditJobsByTag.rejected]: (state, action) => {
            if (state.activeLogBulkEditJobsRequestId !== action.meta.requestId) return;

            state.isLoadingActiveLogBulkEditJobs = false;
            state.activeLogBulkEditJobsError = true;
        },
        [getBulkEditJobByModule.pending]: (state, action) => {
            state.isLoadingGetBulkEditJobByModule = true;
            state.error = false;
        },
        [getBulkEditJobByModule.fulfilled]: (state, action) => {
            state.isLoadingGetBulkEditJobByModule = false;
            state.jobDetails = action?.payload;
            state.error = false;
        },
        [getBulkEditJobByModule.rejected]: (state, action) => {
            state.isLoadingGetBulkEditJobByModule = false;
            state.error = true;
        },
        [editBulkGoals.fulfilled]: (state, action) => {
            state.jobDetails = action?.payload;
        },
        [logoutUser.fulfilled]: (state) => {
            return initialState;
        },
        [logoutUser.rejected]: (state) => {
            return initialState;
        }

    }
});

export const getError = (state) => state.job.error;
export const getIsLoadingGetBulkEditJobById = (state) => state.job.isLoadingGetBulkEditJobById;
export const getIsLoadingGetBulkEditJobByTagId = (state) => state.job.isLoadingGetBulkEditJobByTagId;
export const getIsLoadingGetBulkEditJobByModule = (state) => state.job.isLoadingGetBulkEditJobByModule;
export const getIsLoadingActiveLogBulkEditJobs = (state) => state.job.isLoadingActiveLogBulkEditJobs;
export const getActiveLogBulkEditJobs = (state) => state.job.activeLogBulkEditJobs;
export const getActiveLogBulkEditJobsTagId = (state) => state.job.activeLogBulkEditJobsTagId;
export const getActiveLogBulkEditJobsError = (state) => state.job.activeLogBulkEditJobsError;
export const getJobDetails = (state) => state.job.jobDetails;

export default jobSlice;
